import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// These are the same defaults enforced server-side; used as a fallback when the
// public content endpoint is unreachable.
const DEFAULTS = {
  "company.intro":
    "Gold Petroleum FZ LLC is a UAE-registered company engaged in the trading and distribution of petroleum and petroleum products, with a dedicated focus on non-manufactured precious metals.",
  "company.vision":
    "To become a leading facilitator of oil, gas, derivatives and metals business across the Middle East, Africa and Asia.",
  "company.mission":
    "To build lasting relationships that create value for customers and other stakeholders through transparent communication and efficient business practices.",
  "leadership.message":
    "Our journey has been defined by the trust of our customers and the strength of our stakeholders. We are committed to our values — transparency, consistency, efficiency and shared value — and to the hard work required to build an international company that endures. To everyone who has believed in Gold Petroleum, thank you. The best of what we can achieve together is still ahead.",
  "leadership.short_quote":
    "We build lasting relationships that create shared value for every stakeholder.",
  "careers.body":
    "We welcome high achievers who show initiative and think creatively. Gold Petroleum is a growing international company that values people who bring energy, judgement and a collaborative mindset.",
  "contact.ken.title": "President & CEO",
  // Personal phone attribution to Ken removed 2026-09-16 — telephone is a
  // company-level line rendered via /app/frontend/src/data/contact.js.
  "contact.ken.uae_phone": "",
  "contact.ken.canada_phone": "",
  "contact.fabio.title": "Sales",
  "contact.fabio.uae_phone": "",
  "contact.fabio.canada_phone": "+1 416 277 5262",
  "contact.sales_email": "sales@gpfzllc.com",
};

const Ctx = createContext(DEFAULTS);

export function PageContentProvider({ children }) {
  const [values, setValues] = useState(DEFAULTS);

  useEffect(() => {
    axios
      .get(`${API}/public/page-content`)
      .then((r) => {
        const payload = r.data || {};
        // Support both the wrapped {content, version} shape and the legacy flat dict.
        const content = payload && typeof payload.content === "object" ? payload.content : payload;
        setValues({ ...DEFAULTS, ...(content || {}) });
      })
      .catch(() => {
        /* Fall back to defaults silently. */
      });
  }, []);

  return <Ctx.Provider value={values}>{children}</Ctx.Provider>;
}

export function usePageContent() {
  return useContext(Ctx);
}

export function telHref(phone) {
  return `tel:${(phone || "").replace(/[^0-9+]/g, "")}`;
}
